import React, { PureComponent } from 'react'
import StripeCheckout from 'react-stripe-checkout'
import PropTypes from 'prop-types'
import styles from './styles.css'

export default class StripeBuy extends PureComponent {
  static propTypes = {
    email: PropTypes.string.isRequired,
    plan: PropTypes.string.isRequired,
    subscriptionType: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    amountCents: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onToken: PropTypes.func.isRequired,
    planType: PropTypes.string.isRequired,
    storeType: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
  }

  render() {
    const {
      email,
      plan,
      subscriptionType,
      planType,
      description,
      amountCents,
      label,
      onToken,
      storeType,
      disabled,
    } = this.props
    const labelParts = label.split('/')
    return (
      <StripeCheckout
        name="People-OnTheGo"
        description={description}
        image="https://s3-us-west-2.amazonaws.com/hmm-public/stripe/logo.png"
        amount={amountCents}
        currency="USD"
        // email={email}
        zipCode
        allowRememberMe={false}
        token={token =>
          onToken({
            plan,
            subscriptionType,
            planType,
            token,
            storeType,
          })
        }
        // stripeKey="pk_test_5NKuktVR8PfEZo023kIfPp8Q"
        stripeKey="pk_live_gyhbLmWWgDyTTXXddqvgQvgU"
        disabled={disabled}
      >
        <button type={disabled ? 'disabled' : 'submit'}>
          <span>{labelParts[0]}</span>
          <span style={{ fontSize: 10 }}> /{labelParts[1]}</span>
        </button>
      </StripeCheckout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/subscribe/stripe-buy.js